const CompanyDetails = require('./index.jsx').default;

module.exports = angular
  .module('bench.app.mainapp.details.companyDetails', [])
  .directive('companyDetails', [
    'reactDirective',
    reactDirective => reactDirective(CompanyDetails),
  ]);
